import ListAdministrators from "../../../../components/@groups/administrators/ListAdministrators";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AdministratorGroupsPage() {

    return (
        <ListAdministrators 
            routeType={routeTypes.admin}
        />
    )
}       